import React, { useEffect, useState } from "react";
import { colors, fonts } from "../../../Styles";

export default function WaitAnimation({color = colors.greyDarkPrimary }: {color?: colors}) {
  const [dots, setDots] = useState("");

  useEffect(() => {
    let count = 0;
    let timeout: NodeJS.Timeout;

    const loop = () => {
      if (count < 3) {
        setDots(".".repeat(count + 1));
        count++;
        timeout = setTimeout(loop, 250);
      } else {
        timeout = setTimeout(() => {
          count = 0;
          setDots("");
          loop();
        }, 500); // wait 2 seconds before restarting
      }
    };

    loop();

    return () => clearTimeout(timeout);
  }, []);

  return <span style={{ ...fonts.paragraph, ...fonts.fontSize4, color, minWidth: "3ch", }}>{dots}</span>;
}